import React, {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {IoMdEye} from 'react-icons/io';
import {NavLink} from 'react-router-dom';
import {useGetTestSubmissionQuery} from '../api/codingSubmission';
import CustomTable from '../components/common/CustomTable';
import SubjectDropdown from '../components/common/SubjectDropdown';
import InputField from '../components/ui/InputField';
import {SelectFieldHookForm} from '../components/ui/SelectField';
import {pageRoutes} from '../routes';
import {
  difficultyLevel,
  difficultyLevelOptions,
  testStatus,
} from '../utils/constants';

const CodingSubmission = () => {
  const [formData, setFormData] = useState({
    search: '',
    sort: null,
    sortBy: null,
    page: 1,
    limit: 10,
  });

  const {data: allProblemTest, isFetching: isTestLoading} =
    useGetTestSubmissionQuery(formData);

  const {
    allProblemTest: allProblemTestMain,
    totalItems = null,
    totalPages = null,
  } = allProblemTest?.data || {
    allProblemTest: [],
    totalItems: 0,
    totalPages: 0,
  };

  const allTestSubmission =
    allProblemTest?.data.length === 0 ? [] : allProblemTestMain;

  const {handleSubmit, control, watch, register} = useForm({
    mode: 'all',
  });

  const handleFormSubmission = async (values) => {
    const {search, difficulty, subject} = values;
    let payload = {search};

    if (difficulty?.value) payload = {...payload, difficulty: difficulty.value};

    if (subject?.value) payload = {...payload, subject: subject.value};

    // set pagination to page 1
    setFormData((prev) => ({
      ...prev,
      ...payload,
      page: 1,
    }));
  };

  useEffect(() => {
    const subscription = watch(handleSubmit(handleFormSubmission));
    return () => subscription.unsubscribe();
  }, [handleSubmit, watch]);

  const handleSort = (sortingDetails) => {
    const {page = null, sortBy, sortDirection = null} = sortingDetails;
    setFormData((prevFormData) => ({
      ...prevFormData,
      page: page || prevFormData.page,
      sortBy,
      sort: sortDirection,
    }));
  };

  const tHeadData = [
    {
      id: 1,
      keyIndex: 'username',
      label: 'Name',
      sort: true,
      width: '20%',
    },
    {
      id: 2,
      keyIndex: 'problemName',
      label: 'Problem name',
      sort: true,
      width: '20%',
    },
    {
      id: 3,
      keyIndex: 'subject',
      label: 'Subject',
      sort: true,
      width: '15%',
    },

    {
      id: 4,
      keyIndex: 'problemDifficulty',
      label: 'Difficulty',
      render: (item) => difficultyLevel[item] || '-',
      width: '10%',
    },
    {
      id: 5,
      keyIndex: 'problemScore',
      label: 'Problem Score',
      sort: true,
      width: '15%',
    },
    {
      id: 6,
      keyIndex: 'score',
      label: 'Score',
      sort: true,
      width: '10%',
      render: (item) => item || '-',
    },
    {
      id: 7,
      keyIndex: 'status',
      label: 'status',
      sort: true,
      render: (item) => testStatus[item] || '-',
      width: '25%',
    },
    {
      id: 8,
      keyIndex: '_id',
      label: 'Action',
      width: '10%',
      render: (testId) => (
        <div className="flex gap-2">
          <NavLink
            aria-label="show candidat details"
            to={`${pageRoutes.viewTestSubmission}/${testId}`}
          >
            <IoMdEye size={23} />
          </NavLink>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="px-8 py-6">
        <div className="flex items-center gap-2">
          <h3 className="text-2xl font-bold">
            All test submission
            {!!Number(totalItems) && `(${totalItems})`}
          </h3>
        </div>
        <form className="py-5">
          <div className="flex justify-between gap-4">
            <div className="gap-4 grid grid-cols-3 self-center">
              <SubjectDropdown
                placeholder="Subject"
                control={control}
                name="subject"
                className="w-full max-w-60 bg-white"
              />

              {/* <SelectFieldHookForm
                placeholder="Difficulty"
                control={control}
                name="difficulty"
                options={difficultyLevelOptions}
                className="w-full max-w-60 bg-white"
              /> */}

              <InputField
                {...register('search')}
                type="search"
                placeholder="Search"
              />
            </div>
          </div>
        </form>

        <div className="bg-[white] p-10 border">
          <CustomTable
            tHeadData={tHeadData}
            tBodyData={allTestSubmission}
            handleSort={handleSort}
            pageCount={totalPages}
            currentPage={formData.page}
            loading={isTestLoading}
          />
        </div>
      </div>
    </>
  );
};

export default CodingSubmission;
